<template>
  <div>
    <template>
      <div v-for="(desembolso, i) in form" :key="i">
        <div class="d-flex">
          <div class="row">
            <input-text
              :class="`col-12 col-md-3`"
              label="Tipo"
              v-model="desembolso.tipo"
              readonly
              ref="tipo"
              required
            ></input-text>
            <input-text
              class="col-12 col-md-1"
              label="Parcela"
              type="number"
              v-model="desembolso.parcela"
              ref="parcela"
              required
            />
            <input-money
              :class="`col-12 col-md-3`"
              label="Valor"
              v-model="desembolso.valor"
              ref="tipo"
            />
            <input-select
              class="col-12 col-md-5"
              label="Empresa investidora"
              v-model="desembolso.empresa"
              :options="options.empresas"
              ref="empresa"
              required
            />
            <input-select
              :class="`col-12 col-md-${
                verificarSubtipo(desembolso.subtipo) ? 4 : 6
              }`"
              label="Vincular produto"
              v-model="desembolso.subtipo"
              :options="options.subtipo"
              ref="tipo"
              required
            />
            <input-select
              class="col-12 col-md-4"
              v-if="verificarSubtipo(desembolso.subtipo)"
              label="Entregáveis"
              v-model="desembolso.entregavelId"
              :options="retornarEntregaveis(desembolso.subtipo)"
              ref="entregavel"
              required
            />
            <input-select
              :class="`col-12 col-md-${
                verificarSubtipo(desembolso.subtipo) ? 4 : 6
              }`"
              label="Previsão de desembolso"
              v-model="desembolso.prazo"
              :options="mesesDepesas"
              ref="mes"
              required
            ></input-select>
            <b-button
              v-if="form.length > 1"
              @click="removerLinha(desembolso)"
              class="ml-3 col-12 col-md-2"
              variant="outline-danger"
            >
              <i class="fas fa-trash mr-2"></i>
              Remover parcela
            </b-button>
          </div>
        </div>
        <hr />
      </div>
      <div>
        <b-button
          v-if="!editando"
          @click="adicionarLinha"
          class="ml-2"
          variant="info"
        >
          <i class="fas fa-plus"></i>
          Adicionar parcela
        </b-button>
      </div>
    </template>
  </div>
</template>
<script>
import InputSelect from "@/components/inputs/InputSelect";
import InputText from "@/components/inputs/InputText";
import InputMoney from "@/components/inputs/InputMoney";

import ProjetoService from "@/common/services/projeto/projeto.service";

import { FormMixin } from "@/common/mixins/FormMixin";

import helpers from "@/common/utils/helpers";

export default {
  name: "ModalCronogramaFinanceiroNPrevisto",
  mixins: [FormMixin],
  props: {
    duracao: {
      required: true,
    },
    dataInicio: {
      required: true,
    },
    form: {
      required: true,
    },
    projetoId: {
      type: String,
    },
    projetoIdBase: {
      type: String,
    },
    editando: {
      type: Boolean,
    },
  },
  components: {
    InputSelect,
    InputText,
    InputMoney,
  },
  data: () => ({
    options: {
      subtipo: helpers.getSubTiposCronogramaFinanceiro(),
      empresas: [],
      entregaveis: [],
    },
  }),
  methods: {
    formatarTextoEntregavel(entregavel) {
      if (
        entregavel.tipo == "RelatorioAtividades" &&
        entregavel.vinculadoARelatorioEtapa
      )
        return entregavel.relatorioEtapa.titulo;

      let tipoEntregavel = helpers.getTipoEntregavel(entregavel.tipo.trim());
      let texto = tipoEntregavel.text;
      if (tipoEntregavel.value != tipoEntregavel.subtipo)
        texto = `${helpers.getEnum(tipoEntregavel.subtipo).text}`;
      return `${texto} ${entregavel.sequencial}`;
    },
    retornarEntregaveis(subtipo) {
      if (subtipo == null) return [];
      return this.options.entregaveis
        .filter((el) => {
          return el.subtipo.trim() == subtipo.trim();
        })
        .sort((a, b) => {
          return a.text.localeCompare(b.text);
        });
    },
    adicionarLinha: function () {
      this.form.push({
        tipo: `Nota fiscal ${
          this.form.length == 0
            ? 1
            : parseInt(
                this.form[this.form.length - 1].tipo.replace("Nota fiscal ", "")
              ) + 1
        }`,
        subtipo: null,
        prazo: null,
        valor: 0,
        parcela:
          this.form.length == 0
            ? 1
            : parseInt(this.form[this.form.length - 1].parcela) + 1,
        entregavelId: null,
        previsto: false,
      });
    },
    removerLinha: function (linha) {
      this.form.splice(this.form.indexOf(linha), 1);
    },
    verificarSubtipo: function (subtipo) {
      switch (subtipo) {
        case null:
          return false;
        case "SemVinculo":
          return false;
        case "AssinaturaDoContrato":
          return false;
        case "RelatorioFinal":
          return false;
        default:
          return true;
      }
    },

    buscarEmpresas: function () {
      ProjetoService.listarEmpresasInvestidoras(this.projetoIdBase).then(
        (res) => {
          this.options.empresas = res.data.data.map((el) => {
            return {
              text: el.razaoSocial,
              value:
                el.projetoInvestidoraId || el.projetoCooperadaInvestidoraId,
            };
          });
        }
      );
    },

    buscarEntregaveis: function () {
      ProjetoService.listarEntregaveis(this.projetoIdBase).then((res) => {
        this.options.entregaveis = res.data.data.map((entregavel) => {
          return {
            text: this.formatarTextoEntregavel(entregavel),
            value: entregavel.id,
            subtipo: entregavel.vinculadoARelatorioEtapa
              ? "RelatorioDeEtapas"
              : entregavel.tipo,
          };
        });
      });
    },
  },
  mounted: function () {
    this.buscarEmpresas();
    this.buscarEntregaveis();
  },
  computed: {
    mesesDepesas: function () {
      return helpers.criarArrayMes(this.dataInicio, this.duracao);
    },
  },
  watch: {
    form: {
      handler: function () {
        let valorNotas = this.form.reduce((total, el) => {
          return total + parseFloat(helpers.removerValor(`${el.valor}`));
        }, 0);
        this.$emit("notas", valorNotas);
      },
      deep: true,
    },
  },
};
</script>
<style lang=""></style>
